import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.MobileCheckins = routerStyxie({ actions: ['index', 'new', 'edit']})
